import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import qs from 'query-string';

import { userSelectors } from 'reducers';
import { useMatchAtLeastOneRole } from 'utils/hooks';
import { queryStringifyOptions, RoleNames } from 'utils/constants';

import DashboardTemplate from '../common-components/DashboardTemplate';
import ActionsToTake from './ActionsToTake';
import InProgressSection from './InProgressSection';
import CompletedSection from './CompletedSection';
import NetworkAdminWelcome from './NetworkAdminWelcome';

const ServicerDashboard = () => {
    const history = useHistory();
    const internalUser = useSelector(userSelectors.getInternalUser);
    const userIsNetworkAdmin = useMatchAtLeastOneRole([RoleNames.NETWORK_ADMIN]);
    const hasAssignedNetwork = !!internalUser?.adminNetworks?.length;

    const handleInfoCardFilter = useCallback(
        (payload, listType) => () => {
            history.push({
                pathname: `/${listType}`,
                search: `?${qs.stringify(payload, queryStringifyOptions)}`,
            });
        },
        [history]
    );

    return userIsNetworkAdmin && !hasAssignedNetwork ? (
        <NetworkAdminWelcome firstName={internalUser?.firstName} />
    ) : (
        <DashboardTemplate>
            {!userIsNetworkAdmin && <ActionsToTake onListFilter={handleInfoCardFilter} />}
            <InProgressSection
                onListFilter={handleInfoCardFilter}
                userIsNetworkAdmin={userIsNetworkAdmin}
                userIsServicer
            />
            <CompletedSection
                onListFilter={handleInfoCardFilter}
                userIsNetworkAdmin={userIsNetworkAdmin}
                userIsServicer
            />
        </DashboardTemplate>
    );
};

export default ServicerDashboard;
